// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2BJ2V","right":"styles_right__xLSKm"};